import { designService } from '@paragon/data-connections';

import {
  lumberOptionsFailedLoading,
  lumberOptionsFinishedLoading,
  lumberOptionsStartedLoading,
} from '../store/lumberOptionsSlice';
import { AsyncThunkActionVoid } from './thunkActionTypes';

export const loadLumberOptions = (): AsyncThunkActionVoid => async (dispatch) => {
  dispatch(lumberOptionsStartedLoading());

  try {
    const lumberOptions = await designService.materialLists.getLumberSpeciesAndGradeOptions();
    dispatch(lumberOptionsFinishedLoading(lumberOptions));
  } catch (error: any) {
    dispatch(lumberOptionsFailedLoading(error.message ?? ''));
  }
};
